module.exports = __webpack_public_path__ + "static/media/gratitude_card.d54fddde.jpg";